<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <Tab type="coupon" />

      <div class="page-actions">
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input
                v-model.trim="filters.userId"
                placeholder="用户UID"
                clearable
                size="mini"
                prefix-icon="el-icon-search"
                @keyup.enter.native="handleSearch"
              />
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input
                v-model.trim="filters.couponIdOrName"
                placeholder="卡券ID/名称"
                clearable
                size="mini"
                prefix-icon="el-icon-search"
                @keyup.enter.native="handleSearch"
              />
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="filters.couponType" placeholder="卡券类型" clearable size="mini">
                <el-option
                  v-for="item in couponTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="filters.couponStatus" placeholder="用户卡券状态" clearable size="mini">
                <el-option
                  v-for="item in couponStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="item">
            <el-date-picker
              v-model="filters.issueRange"
              type="datetimerange"
              value-format="timestamp"
              range-separator="至"
              start-placeholder="发放开始时间"
              end-placeholder="发放结束时间"
              size="mini"
            />
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch">查询</el-button>
          </div>
          <div class="item">
            <el-button size="mini" @click="handleReset">重置</el-button>
          </div>
        </div>
      </div>

      <el-table :data="tableList" height="calc(100vh - 320px)" size="mini" v-loading="loading">
        <el-table-column prop="userId" label="用户UID" min-width="120" show-overflow-tooltip />
        <el-table-column prop="couponNo" label="卡券ID" min-width="160" show-overflow-tooltip />
        <el-table-column prop="couponName" label="卡券名称" min-width="140" show-overflow-tooltip />
        <el-table-column prop="couponTypeDesc" label="卡券类型" min-width="110">
          <template slot-scope="scope">
            {{ scope.row.couponTypeDesc || couponTypeMap[scope.row.couponType] || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="coin" label="币种" width="80">
          <template slot-scope="scope">{{ formatValue(scope.row.coin) }}</template>
        </el-table-column>
        <el-table-column prop="couponAmount" label="卡券金额" min-width="100">
          <template slot-scope="scope">{{ formatValue(scope.row.couponAmount) }}</template>
        </el-table-column>
        <el-table-column prop="vipLevel" label="VIP等级" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.vipLevel === null || scope.row.vipLevel === undefined ? '--' : `VIP${scope.row.vipLevel}` }}
          </template>
        </el-table-column>
        <el-table-column prop="vipValidDays" label="VIP有效天数" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.vipValidDays === null || scope.row.vipValidDays === undefined ? '--' : `${scope.row.vipValidDays}天` }}
          </template>
        </el-table-column>
        <el-table-column prop="couponStatusDesc" label="用户卡券状态" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.couponStatusDesc || couponStatusMap[scope.row.couponStatus] || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="issueTime" label="发放时间" min-width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.issueTime) }}</template>
        </el-table-column>
        <el-table-column prop="receiveTime" label="奖励领取时间" min-width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.receiveTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="90" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.canRetryGrant"
              type="text"
              size="mini"
              :loading="retryGrantId === scope.row.userCouponId"
              :disabled="retryGrantId !== null"
              @click="handleRetryGrant(scope.row)"
            >
              补发
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pag">
        <pagination
          :size="pagination.size"
          :total="totalCount"
          :page="pagination.page"
          @pageChanged="pageChanged"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import moment from 'moment'
import Pagination from 'components/pagination'
import Tab from '../components/Tab'
import api from './api'
import {
  PAGINATION,
  COUPON_TYPE_OPTIONS,
  COUPON_TYPE_MAP,
  COUPON_STATUS_OPTIONS,
  COUPON_STATUS_MAP,
} from './constants'

function createFilters() {
  return {
    userId: '',
    couponIdOrName: '',
    couponType: '',
    couponStatus: '',
    issueRange: [],
  }
}

export default {
  name: 'WelfareCouponRecord',
  components: { Pagination, Tab },
  data() {
    return {
      loading: false,
      filters: createFilters(),
      couponTypeOptions: COUPON_TYPE_OPTIONS,
      couponTypeMap: COUPON_TYPE_MAP,
      couponStatusOptions: COUPON_STATUS_OPTIONS,
      couponStatusMap: COUPON_STATUS_MAP,
      tableList: [],
      totalCount: 0,
      pagination: { ...PAGINATION },
      retryGrantId: null,
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    formatValue(value) {
      return value === null || value === undefined || value === '' ? '--' : value
    },
    formatTime(value) {
      return value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : '--'
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
    },
    handleReset() {
      this.filters = createFilters()
      this.pagination = { ...PAGINATION }
      this.fetchList()
    },
    pageChanged({ page, size }) {
      this.pagination = { page, size }
      this.fetchList()
    },
    buildQuery() {
      const query = {
        page: this.pagination.page,
        size: this.pagination.size,
      }
      const { userId, couponIdOrName, couponType, couponStatus, issueRange } = this.filters
      if (userId) query.userId = userId
      if (couponIdOrName) query.couponIdOrName = couponIdOrName
      if (couponType) query.couponType = couponType
      if (couponStatus) query.couponStatus = couponStatus
      if (issueRange && issueRange.length === 2) {
        query.issueStartTime = issueRange[0]
        query.issueEndTime = issueRange[1]
      }
      return query
    },
    fetchList() {
      this.loading = true
      return api
        .list(this.buildQuery())
        .then((res) => {
          if (res && res.code === 0) {
            const data = res.data || {}
            this.tableList = data.items || data.records || data.list || []
            this.totalCount =
              data.total != null ? data.total : data.totalCount != null ? data.totalCount : 0
          } else {
            this.tableList = []
            this.totalCount = 0
            this.$message.error((res && (res.msg || res.message)) || '查询失败')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleRetryGrant(row) {
      if (!row || !row.canRetryGrant) {
        this.$message.warning('仅发放失败状态支持补发')
        return
      }
      if (!row.userCouponId) {
        this.$message.warning('缺少用户卡券记录ID，无法补发')
        return
      }
      if (this.retryGrantId !== null) return

      this.$confirm('确认补发该用户卡券吗？', '补发确认', {
        type: 'warning',
        confirmButtonText: '确认补发',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.retryGrantId = row.userCouponId
          return api
            .retryGrant({ userCouponId: row.userCouponId })
            .then((res) => {
              if (res && res.code === 0) {
                if (res.data === true) {
                  this.$message.success('补发成功')
                } else {
                  this.$message.warning('补发已受理，正在刷新状态')
                }
                return this.fetchList()
              }
              this.$message.error((res && (res.msg || res.message)) || '补发失败')
            })
            .catch(() => {
              this.$message.error('补发失败，请稍后重试')
            })
            .finally(() => {
              this.retryGrantId = null
            })
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
<style lang="less" scoped>
.pag {
  display: flex;
  justify-content: center;
}
</style>
